/**
 * Converts an xml document to a json object
 *
 * @param {Document} xml An xml document to be converted
 * @return {object}
 */
export default function xmlToJson(xml) {
  let json = {};

  // Get attributes from the current node
  if (xml.attributes && xml.attributes.length > 0) {
    json['@attributes'] = {};

    for (let i = 0; i < xml.attributes.length; i++) {
      json['@attributes'][xml.attributes[i].nodeName] = xml.attributes[i].nodeValue;
    }
  }

  // Add properties to the current node for each child node
  for (let i = 0; i < xml.childNodes.length; i++) {
    // Text nodes are added to the current node as #text properties
    if (xml.childNodes[i].nodeType === 3 || xml.childNodes[i].nodeType === 4) {
      if (xml.childNodes[i].textContent.trim() !== '') {
        json['#text'] = xml.childNodes[i].textContent.trim();
      }
      continue;
    }

    if (json[xml.childNodes[i].tagName] !== undefined) {
      if (!Array.isArray(json[xml.childNodes[i].tagName])) {
        json[xml.childNodes[i].tagName] = [json[xml.childNodes[i].tagName]];
      }

      json[xml.childNodes[i].tagName].push(xmlToJson(xml.childNodes[i]));
    } else {
      json[xml.childNodes[i].tagName] = xmlToJson(xml.childNodes[i]);
    }
  }

  return json;
};